module.exports = __webpack_public_path__ + "static/img/missed.3f569ac.png";